var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDoNotBleach = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 7.65 7.91",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m5.48 2.91 2.11-2.12-.44-.44-2 2-1.33-2.35-1.34 2.36-2-2-.48.44 2.16 2.12-2.16 3.8h.81l-.75.75.44.44 1.18-1.19h4.32l1.17 1.18.44-.44-.74-.74h.78zm-1.66-1.83.95 1.66-.95.95-.94-.94zm-2.48 5.1h-.42l1.64-2.87.82.82zm.88 0 1.61-1.61 1.62 1.61zm4.11 0-2.07-2 .83-.83 1.64 2.83z",
    fill: "#313332"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDoNotBleach);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "DoNotBleach.0c6ce756040bea7b0497bb51425cd84d.svg";